import React from 'react';

const TransactionLaw = () => {
  return (
    <div style={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      padding: '20px',
      lineHeight: '1.6',
      color: '#333'
    }}>
      <h1 style={{ 
        textAlign: 'center', 
        color: '#2c3e50',
        marginBottom: '30px',
        fontSize: '28px'
      }}>
        特定商取引法に基づく表記
      </h1>

      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '25px',
        borderRadius: '8px',
        marginBottom: '30px',
        border: '1px solid #e9ecef'
      }}>
        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
          特定商取引法に基づき、以下の事項を明記いたします。
        </p>
        <p style={{ fontSize: '16px' }}>
          本サービスをご利用になる前に、必ずご確認ください。
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          事業者の名称
        </h3>
        <p style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          株式会社スタート
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          代表者
        </h3>
        <p style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          運営責任者 橋田 信介
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          所在地
        </h3>
        <p style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          〒151-0064<br />
          東京都渋谷区西原2-16-4<br />
          Shinmei203
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          連絡先
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '10px' }}>
            <strong>電話番号：</strong>03-6416-5484
          </p>
          <p style={{ marginBottom: '10px' }}>
            <strong>受付時間：</strong>平日 9:00〜18:00<br/>
            <strong>営業時間：</strong>平日 9:00〜17:00
          </p>
          <p style={{ marginBottom: '10px' }}>
            <strong>メールアドレス：</strong>nwo123123@yahoo.co.jp
          </p>
          {/* <p>
            <strong>FAX：</strong>03-1234-5679
          </p> */}
        </div>
      </div>

      {/* <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          運営責任者
        </h3>
        <p style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          取締役 佐藤 花子
        </p>
      </div> */}

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          販売価格
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '10px' }}>
            各商品・サービスの価格は、当ウェブサイトに表示される価格に従います。
          </p>
          <p style={{ marginBottom: '10px' }}>
            価格は全て税込表示です。
          </p>
          <p>
            価格は予告なく変更される場合があります。
          </p>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          商品代金以外の必要料金
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '10px' }}>
            <strong>送料：</strong>無料
          </p>
          <p style={{ marginBottom: '10px' }}>
            <strong>手数料：</strong>銀行振込の場合、振込手数料はお客様負担となります
          </p>
          <p>
            <strong>その他：</strong>特にございません
          </p>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          支払方法
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <ul style={{ marginLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>銀行振込</li>
            <li style={{ marginBottom: '8px' }}>Smart Pit（コンビニ決済）</li>
            <li style={{ marginBottom: '8px' }}>クレジットカード決済</li>
          </ul>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          支払時期
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <ul style={{ marginLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>銀行振込：商品発送前</li>
            <li style={{ marginBottom: '8px' }}>Smart Pit：商品発送前</li>
            <li style={{ marginBottom: '8px' }}>クレジットカード：商品発送前</li>
          </ul>
        </div>
      </div>

      {/* <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          商品の引き渡し時期
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '10px' }}>
            デジタルコンテンツ（ポイント等）は、決済完了後即座にご利用いただけます。
          </p>
          <p>
            物理的商品がある場合は、決済完了後3営業日以内に発送いたします。
          </p>
        </div>
      </div> */}

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          返品・キャンセルについて
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <h4 style={{ 
            color: '#e74c3c', 
            marginBottom: '10px',
            fontSize: '16px'
          }}>
            返品・キャンセル不可
          </h4>
          <p style={{ marginBottom: '10px' }}>
            デジタルコンテンツ（ポイント等）は、ご購入後の返品・キャンセルはできません。
          </p>
          <p style={{ marginBottom: '10px' }}>
            ただし、以下の場合は返金対応いたします：
          </p>
          <ul style={{ marginLeft: '20px' }}>
            <li style={{ marginBottom: '5px' }}>システム障害によりサービスが利用できない場合</li>
            <li style={{ marginBottom: '5px' }}>当社の過失によりサービスが提供できない場合</li>
            <li style={{ marginBottom: '5px' }}>法令に基づく返金義務がある場合</li>
          </ul>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          返品・交換について
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '10px' }}>
            デジタルコンテンツのため、返品・交換はできません。
          </p>
          <p>
            物理的商品がある場合は、商品到着後7日以内に限り、不良品の交換を承ります。
          </p>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          解約・中途解約について
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '10px' }}>
            月額サービス等の継続サービスについては、いつでも解約可能です。
          </p>
          <p style={{ marginBottom: '10px' }}>
            解約は、当社指定の方法でお申し込みください。
          </p>
          <p>
            解約後は、既に支払い済みの料金の返金はいたしません。
          </p>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          解約・中途解約の手続き
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '10px' }}>
            解約をご希望の場合は、以下の方法でお申し込みください：
          </p>
          <ul style={{ marginLeft: '20px' }}>
            <li style={{ marginBottom: '5px' }}>お客様ページの設定画面から解約手続き</li>
            <li style={{ marginBottom: '5px' }}>お問い合わせフォームからの解約申し込み</li>
            <li style={{ marginBottom: '5px' }}>電話での解約申し込み</li>
          </ul>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          解約・中途解約の手数料
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p>
            解約手数料は無料です。
          </p>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          解約・中途解約の返金
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '10px' }}>
            解約後は、既に支払い済みの料金の返金はいたしません。
          </p>
          <p>
            ただし、契約期間の途中で解約した場合、未使用期間分の返金を行う場合があります。
          </p>
        </div>
      </div>

      {/* <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          運送時の損害の責任所在
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p>
            デジタルコンテンツのため、運送時の損害は発生しません。
          </p>
        </div>
      </div> */}

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          クーリングオフについて
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p style={{ marginBottom: '10px' }}>
            デジタルコンテンツのため、クーリングオフは適用されません。
          </p>
          <p>
            ただし、法令で定められた場合を除きます。
          </p>
        </div>
      </div>

      {/* <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          資格・免許
        </h3>
        <div style={{ 
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <p>
            出会い系サービス事業者として、東京都知事の許可を受けています。<br />
            許可番号：東京都知事（出会い系）第123456号
          </p>
        </div>
      </div> */}

      <div style={{
        backgroundColor: '#d4edda',
        padding: '20px',
        borderRadius: '6px',
        border: '1px solid #c3e6cb',
        color: '#155724',
        textAlign: 'center'
      }}>
        <h3 style={{ marginBottom: '15px' }}>お問い合わせ</h3>
        <p style={{ marginBottom: '10px' }}>
          特定商取引法に関するご質問がございましたら、お気軽にお問い合わせください。
        </p>
        <p style={{ fontWeight: 'bold' }}>
          お問い合わせ先：nwo123123@yahoo.co.jp
        </p>
        <p style={{ fontSize: '14px', marginTop: '15px' }}>
          最終更新日：2025年8月20日
        </p>
      </div>
    </div>
  );
};

export default TransactionLaw; 